module.exports = __webpack_public_path__ + "static/media/elo.35876931.png";